import { z } from 'zod'

export const EditMedicalActProtocolSchema = z.object({
	medicalActs: z.array(
		z.object({
			quantity: z.number().min(1),
			medicalActId: z.string(),
			serviceProviderId: z.string().optional(),
		})
	),
})
